import ActionBarLink from './ActionBarLink';

export default ActionBarLink;
